import { useQuery } from "@tanstack/react-query";

import ContentWrapper from "~/components/ContentWrapper";
import { billingSettingsQueries } from "~/modules/billing/api/billingSettings/billingSettingsQueries.ts";
import BillingTabSubNavigation
	from "~/modules/project/components/ProjectDetailsView/components/ProjectBillingSectionTabContent/components/BillingTabSubNavigation.tsx";
import ProjectBillingSettings
	from "~/modules/project/components/ProjectDetailsView/components/ProjectBillingSectionTabContent/components/ProjectBillingSettingsTabContent/ProjectBillingSettings.tsx";
import ProjectInvoicesTabContent
	from "~/modules/project/components/ProjectDetailsView/components/ProjectBillingSectionTabContent/components/ProjectInvoicesTabContent/ProjectInvoicesTabContent.tsx";
import { ProjectDetailsTabName } from "~/modules/project/types/projectViewTypes.ts";
import LoadingPage from "~/pages/LoadingPage.tsx";

type Props = {
	activeTabId: ProjectDetailsTabName | string;
	clientId: string;
	projectId: string;
};

const ProjectBillingSectionTabContent = ({ activeTabId, clientId, projectId }: Props) => {
	if (![ProjectDetailsTabName.Invoices, ProjectDetailsTabName.BillingSettings].includes(activeTabId as ProjectDetailsTabName)) {
		return null;
	}

	const { data: projectBillingSettingsData, isLoading: projectBillingSettingsIsLoading } = useQuery(
		billingSettingsQueries.byProject(projectId),
	);

	if (activeTabId === ProjectDetailsTabName.BillingSettings && projectBillingSettingsIsLoading) {
		return <LoadingPage />;
	}

	if (activeTabId === ProjectDetailsTabName.BillingSettings && !projectBillingSettingsData) {
		return <div className="flex h-full flex-col items-center justify-center">
			<p className="text-lg font-semibold text-gray-700">Keine Abrechnungseinstellungen gefunden</p>
			<p className="text-sm text-gray-500">Bitte wenden Sie sich an den Administrator, um die
				Abrechnungseinstellungen für dieses Projekt zu konfigurieren.</p>
		</div>;
	}

	return <ContentWrapper className="grid size-full grid-rows-[auto_1fr] overflow-hidden">
		<BillingTabSubNavigation activeTabId={activeTabId}
								 projectId={projectId} />
		{activeTabId === ProjectDetailsTabName.Invoices && <ProjectInvoicesTabContent projectId={projectId} />}
		{activeTabId === ProjectDetailsTabName.BillingSettings && projectBillingSettingsIsLoading && <LoadingPage />}
		{activeTabId === ProjectDetailsTabName.BillingSettings && projectBillingSettingsData &&
			<ProjectBillingSettings projectBillingSettings={projectBillingSettingsData}
									clientId={clientId}
									projectId={projectId} />}
	</ContentWrapper>;
};

export default ProjectBillingSectionTabContent;